export default __webpack_public_path__ + "static/media/spa-image-01.9203dfee.jpg";